(function() {
    'use strict';
    angular
        .module('wamasysApp')
        .factory('GlobalExpenseType', GlobalExpenseType);

    GlobalExpenseType.$inject = ['$resource'];

    function GlobalExpenseType ($resource) {
        var resourceUrl =  'api/global-expense-type/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'queryInclDeleted': {
                method: 'GET',
                isArray: true,
                params: {inclDeleted:true}
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
